module.exports = __webpack_public_path__ + "static/media/new-haven.4523586d.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/geojson/new-haven.json
// module id = 865
// module chunks = 27